import * as tslib_1 from "tslib";
export var isDropdownGroup = function (object) {
    return ('items' in object && Array.isArray(object.items) && object.items.length);
};
export var isNullableDropdownGroup = function (object) {
    return ('items' in object && Array.isArray(object.items) && object.items.length);
};
export var convertNullableGroupToDropdownGroup = function (group) {
    var items = group.items.filter(function (item) { return !!item; });
    return items.length > 0 ? tslib_1.__assign({}, group, { items: items }) : undefined;
};
//# sourceMappingURL=types.js.map